class ContactService {
  constructor() {
    // Base URL for the target server
    this.baseURL = 'http://robos4advisors.ca:8080/Test';
    this.fallbackEnabled = true;
  }

  // Contact Us API - sends form data to external server
  async sendContactForm(contactData) {
    console.log('Contact form submission started...');
    console.log('Contact data:', contactData);
    
    try {
      // Prepare payload according to requirements
      const payload = {
        name: contactData.name,
        email: contactData.email,
        subject: contactData.subject,
        message: contactData.message
      };

      console.log('Sending to external API:', payload);

      // Contact Us API - Make API call to external server [Contact Us]
      const response = await fetch(`${this.baseURL}/api/public/ContactUs?RequestType=4&JSON_TYPE=JSON&CommandType=ContactUs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
        signal: AbortSignal.timeout(10000)
      });

      console.log('API Response status:', response.status);

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const result = await response.json();
      console.log('API Response:', result);
      
      return {
        success: true,
        data: result,
        message: 'Contact form sent successfully!',
        method: 'external_api'
      };

    } catch (error) {
      console.error('External API failed:', error);
      
      // Fallback: store locally
      this.storeContactLocally(contactData);
      
      return {
        success: true,
        message: 'Your message has been received! We will contact you soon.',
        note: 'Note: API service is temporarily unavailable, but your message has been saved locally.',
        method: 'local_storage'
      };
    }
  }

  // Book Demo API - sends demo request to external server [Arrange Demo]
  async sendBookDemoForm(demoData) {
    console.log('Book demo submission started...');
    console.log('Demo data:', demoData);
    
    try {
      // Prepare payload for ArrangeDemo endpoint
      const payload = {
        name: demoData.name,
        email: demoData.email,
        company: demoData.company,
        phone: demoData.phone,
        subject: demoData.subject,
        preferredTime: demoData.preferredTime,
        message: demoData.message
      };

      console.log('Sending demo request to external API:', payload);

      // Make API call to external server
      const response = await fetch(`${this.baseURL}/api/public/ArrangeDemo?RequestType=4&JSON_TYPE=JSON&CommandType=ArrangeDemo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
        signal: AbortSignal.timeout(10000)
      });

      console.log('Demo API Response status:', response.status);

      if (!response.ok) {
        throw new Error(`Demo API error: ${response.status}`);
      }

      const result = await response.json();
      console.log('Demo API Response:', result);
      
      return {
        success: true,
        data: result,
        message: 'Demo request sent successfully!',
        method: 'external_api'
      };

    } catch (error) {
      console.error('Demo API failed:', error);
      
      // Fallback: store locally
      this.storeDemoLocally(demoData);
      
      return {
        success: true,
        message: 'Your demo request has been received! We will contact you soon.',
        note: 'Note: API service is temporarily unavailable, but your request has been saved locally.',
        method: 'local_storage'
      };
    }
  }

  // Legacy authentication method (kept for fallback)
  async tryAuthenticationMethod(contactData) {
    console.log('Trying legacy authentication method...');
    
    try {
      const authData = {
        accessorCode: 'homie@cloud.com',
        password: 'Cl0udvis0r'
      };
      
      console.log('Authenticating with server...');
      const authResponse = await fetch(`${this.baseURL}/api/public/log_in?RequestType=48&JSON_TYPE=JSON&CommandType=oneStepLogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(authData),
        signal: AbortSignal.timeout(10000)
      });

      if (!authResponse.ok) {
        throw new Error(`Authentication failed: ${authResponse.status}`);
      }

      const authResult = await authResponse.json();
      console.log('Authentication result:', authResult);
      
      if (authResult.passwordAcceptable === true && authResult.sessionID) {
        console.log('Authentication successful, sending contact data...');
        
        const contactPayload = {
          ...contactData,
          sessionID: authResult.sessionID,
          timestamp: new Date().toISOString()
        };
        
        const contactResponse = await fetch(`${this.baseURL}/api/public/ContactUs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${authResult.sessionID}`
          },
          body: JSON.stringify(contactPayload),
          signal: AbortSignal.timeout(5000)
        });
        
        if (!contactResponse.ok) {
          throw new Error(`Contact submission failed: ${contactResponse.status}`);
        }
        
        const contactResult = await contactResponse.json();
        console.log('Contact submission result:', contactResult);
        
        return {
          success: true,
          data: contactResult,
          message: 'Contact form sent successfully via authentication!',
          sessionID: authResult.sessionID
        };
      } else {
        throw new Error('Authentication failed - invalid credentials');
      }
    } catch (authError) {
      console.error('Authentication method failed:', authError);
      
      this.storeContactLocally(contactData);
      
      return {
        success: true,
        message: 'Your message has been received. We will contact you soon!',
        note: 'Note: Authentication service is temporarily unavailable, but your message has been saved locally.'
      };
    }
  }

  // Store contact form data locally as fallback
  storeContactLocally(contactData) {
    try {
      const storedContacts = JSON.parse(localStorage.getItem('contactMessages') || '[]');
      const newContact = {
        ...contactData,
        type: 'contact',
        timestamp: new Date().toISOString(),
        id: Date.now()
      };
      storedContacts.push(newContact);
      localStorage.setItem('contactMessages', JSON.stringify(storedContacts));
      console.log('Contact message stored locally:', newContact);
    } catch (error) {
      console.error('Failed to store contact locally:', error);
    }
  }

  // Store demo request data locally as fallback
  storeDemoLocally(demoData) {
    try {
      const storedDemos = JSON.parse(localStorage.getItem('demoRequests') || '[]');
      const newDemo = {
        ...demoData,
        type: 'demo',
        timestamp: new Date().toISOString(),
        id: Date.now()
      };
      storedDemos.push(newDemo);
      localStorage.setItem('demoRequests', JSON.stringify(storedDemos));
      console.log('Demo request stored locally:', newDemo);
    } catch (error) {
      console.error('Failed to store demo locally:', error);
    }
  }

  // Utility methods
  getStoredContacts() {
    try {
      return JSON.parse(localStorage.getItem('contactMessages') || '[]');
    } catch (error) {
      console.error('Failed to retrieve stored contacts:', error);
      return [];
    }
  }

  getStoredDemos() {
    try {
      return JSON.parse(localStorage.getItem('demoRequests') || '[]');
    } catch (error) {
      console.error('Failed to retrieve stored demos:', error);
      return [];
    }
  }

  clearStoredContacts() {
    try {
      localStorage.removeItem('contactMessages');
      console.log('Stored contacts cleared');
    } catch (error) {
      console.error('Failed to clear stored contacts:', error);
    }
  }

  clearStoredDemos() {
    try {
      localStorage.removeItem('demoRequests');
      console.log('Stored demos cleared');
    } catch (error) {
      console.error('Failed to clear stored demos:', error);
    }
  }

  getErrorMessage(error) {
    if (error.name === 'AbortError') {
      return 'Request timed out. Please check your internet connection and try again.';
    }
    
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      return 'Network error. Please check your internet connection and try again.';
    }
    
    if (error.message.includes('CORS')) {
      return 'Server configuration error. Please contact support.';
    }
    
    if (error.message.includes('404')) {
      return 'API endpoint not found. Please contact support.';
    }
    
    if (error.message.includes('500')) {
      return 'Server error. Please try again later.';
    }
    
    return 'Failed to send form. Please try again later.';
  }
}

const contactService = new ContactService();
export default contactService;